import * as React from "react";

function SvgDollarSign(props, { color = "#00DFED", width = 20, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4499_18127)">
        <path
          d="M10 0.833984V19.1673M14.1667 4.16732H7.91667C7.14312 4.16732 6.40125 4.47461 5.85427 5.02159C5.30729 5.56857 5 6.31044 5 7.08398C5 7.85753 5.30729 8.5994 5.85427 9.14638C6.40125 9.69336 7.14312 10.0007 7.91667 10.0007H12.0833C12.8569 10.0007 13.5987 10.3079 14.1457 10.8549C14.6927 11.4019 15 12.1438 15 12.9173C15 13.6909 14.6927 14.4327 14.1457 14.9797C13.5987 15.5267 12.8569 15.834 12.0833 15.834H5"
          stroke={props.color || color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4499_18127">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgDollarSign;
